export default "__VITE_ASSET__B$Besld5__"